// export const BASE_API = 'http://localhost:8089'
export const BASE_API = process.env.REACT_APP_API_ENDPOINT;
export const BASE_PATH_API = '';
